/** @format */

import React from 'react';
import { Box } from '@mui/material';

import useHotelNames from '../../hooks/useHotelNames';

export default function PrintHotelName({ left = 135 }) {
  const hotels = useHotelNames();

  if (!hotels.length) {
    return null;
  }

  return (
    <Box
      className="print-hotel-name"
      style={{
        position: 'absolute',
        left: `${left}px`,
        top: '50%',
        transform: 'translateY(-50%)',
      }}
    >
      <Box component="span" className="print-toolbar-divider" />

      {hotels.map((hotel, i) => (
        <React.Fragment key={`${hotel.name}-${i}`}>
          <Box component="span" className="print-hotel-block">
            <Box component="span" className="print-hotel-name-text">
              {hotel.name}
            </Box>

            {hotel.location && (
              <Box component="span" className="print-hotel-location">
                <Box component="span" className="print-hotel-location-dot">
                  •
                </Box>

                {hotel.location}
              </Box>
            )}
          </Box>

          {i < hotels.length - 1 && (
            <Box component="span" className="print-hotel-separator">
              {'&'}
            </Box>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
}
